// Standard Excel indexed palette (first 64). Many files use this for older styles.
export const EXCEL_INDEXED_COLORS = [
  "000000", "FFFFFF", "FF0000", "00FF00", "0000FF", "FFFF00", "FF00FF", "00FFFF",
  "000000", "FFFFFF", "FF0000", "00FF00", "0000FF", "FFFF00", "FF00FF", "00FFFF",
  "800000", "008000", "000080", "808000", "800080", "008080", "C0C0C0", "808080",
  "9999FF", "993366", "FFFFCC", "CCFFFF", "660066", "FF8080", "0066CC", "CCCCFF",
  "000080", "FF00FF", "FFFF00", "00FFFF", "800080", "800000", "008080", "0000FF",
  "00CCFF", "CCFFFF", "CCFFCC", "FFFF99", "99CCFF", "FF99CC", "CC99FF", "FFCC99",
  "3366FF", "33CCCC", "99CC00", "FFCC00", "FF9900", "FF6600", "666699", "969696",
  "003366", "339966", "003300", "333300", "993300", "993366", "333399", "333333",
];

export function rgbToCss(rgb) {
  if (!rgb || typeof rgb !== "string") return undefined;
  const hex = rgb.length === 8 ? rgb.slice(2) : rgb;
  if (!/^[0-9a-fA-F]{6}$/.test(hex)) return undefined;
  return `#${hex}`;
}

export function argbToCss(argb) {
  if (!argb || typeof argb !== "string") return undefined;
  const hex = argb.length === 8 ? argb.slice(2) : argb;
  if (!/^[0-9a-fA-F]{6}$/.test(hex)) return undefined;
  return `#${hex}`;
}

export function clampByte(n) {
  return Math.max(0, Math.min(255, n));
}

export function applyTintToHex(hex, tint) {
  if (typeof tint !== "number" || Number.isNaN(tint) || tint === 0) return hex;
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  const t = Math.max(-1, Math.min(1, tint));
  const blend = (c) => {
    if (t < 0) return clampByte(Math.round(c * (1 + t)));
    return clampByte(Math.round(c + (255 - c) * t));
  };

  const rr = blend(r).toString(16).padStart(2, "0");
  const gg = blend(g).toString(16).padStart(2, "0");
  const bb = blend(b).toString(16).padStart(2, "0");
  return `${rr}${gg}${bb}`;
}

export function resolveExcelColorToCss(color, themeColors) {
  if (!color || typeof color !== "object") return undefined;

  // exceljs sometimes provides argb directly
  if (color.argb) return argbToCss(String(color.argb));

  // theme-based color
  if (typeof color.theme === "number" && Array.isArray(themeColors)) {
    const base = themeColors[color.theme];
    if (base) {
      const tinted = applyTintToHex(base, typeof color.tint === "number" ? color.tint : 0);
      return `#${tinted}`;
    }
  }

  // indexed palette
  if (typeof color.indexed === "number") {
    const base = EXCEL_INDEXED_COLORS[color.indexed];
    if (base) return `#${base}`;
  }

  // rgb (rare)
  if (color.rgb) return rgbToCss(String(color.rgb));

  return undefined;
}
